import { Stack, ToggleButton, ToggleButtonGroup } from "@mui/material"
import { Case, Switch } from "lib/@components/switch"
import { CostMultiplierInput } from "./cost-multiplier-input"
import { CostFixedAmountInput } from "./cost-fixed-amount-input"

export function CostModifierInput({ costKind, multiplier, fixedAmount, onChange }) {
    const kind = costKind === "fixed" ? "fixed" : "multiplier"

    return (
        <Stack direction="row" alignItems="center" spacing={1.5}>
            <ToggleButtonGroup
                exclusive
                size="small"
                value={kind}
                onChange={handleKindChange}
                data-cy="cost-modifier-kind"
            >
                <ToggleButton value="multiplier">Percentage</ToggleButton>
                <ToggleButton value="fixed">Fixed amount</ToggleButton>
            </ToggleButtonGroup>
            <Switch value={kind}>
                <Case when="multiplier">
                    <CostMultiplierInput multiplier={multiplier} onChange={handleMultiplierChange} />
                </Case>
                <Case when="fixed">
                    <CostFixedAmountInput amount={fixedAmount} onChange={handleAmountChange} />
                </Case>
            </Switch>
        </Stack>
    )

    function handleKindChange(_, newKind) {
        if (!newKind || newKind === kind) return
        onChange({ costKind: newKind, multiplier: multiplier ?? 1.0, fixedAmount: fixedAmount ?? 0 })
    }

    function handleMultiplierChange(newMultiplier) {
        onChange({ costKind: "multiplier", multiplier: newMultiplier, fixedAmount: fixedAmount ?? 0 })
    }

    function handleAmountChange(newAmount) {
        onChange({ costKind: "fixed", multiplier: multiplier ?? 1.0, fixedAmount: newAmount })
    }
}
